import PropTypes from 'prop-types';
import { getBackgroundColorClass, stateGrid } from './config';
import StateSelector from './StateSelector';

const HexMap = ({ states, highestStateCount, basePath }) => {
  // ensure that basepath starts with a /
  const fullBasePath = basePath.startsWith('/') ? basePath : `/${basePath}`;

  // In some broad cases where the map appears, there's no states data, so we don't render anything.
  return states ? (
    <>
      <div className="m-4 mx-auto grid max-w-xl grid-cols-12 grid-rows-8 place-content-center gap-px text-center text-xs font-medium min-[539px]:text-sm">
        {stateGrid.map(({ state, component }) => {
          return component({
            backgroundColorClass: getBackgroundColorClass({
              signCount: states[state] || 0,
              maxCount: highestStateCount,
            }),
            basePath: fullBasePath,
          });
        })}
      </div>
      <StateSelector basePath={fullBasePath} />
    </>
  ) : null;
};

HexMap.propTypes = {
  states: PropTypes.objectOf(PropTypes.number),
  highestStateCount: PropTypes.number.isRequired,
};

export default HexMap;
